import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../../assets/css/sass/affiliate.scss";
import { END_POINT } from "../../constants/defaultValues";

const AffiliateForgotPassword = (props) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  // Robust query param extraction
  const search = props.location
    ? props.location.search
    : window.location.search;
  const query = new URLSearchParams(search);
  const token = query.get("token");

  // Mode: "request" (forgot) or "reset" (has token)
  const mode = token ? "reset" : "request";

  useEffect(() => {
    console.log(
      "ForgotPassword Component Mounted. Mode:",
      mode,
      "Token:",
      token
    );
  }, [mode, token]);

  const handleRequest = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const response = await fetch(
        `${END_POINT}/api/affiliate/forgot-password`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setSuccess(data.responseText);
      } else {
        setError(data.responseText || "Có lỗi xảy ra");
      }
    } catch (err) {
      console.error(err);
      setError("Lỗi kết nối server");
    } finally {
      setLoading(false);
    }
  };

  const handleReset = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError("Mật khẩu nhập lại không khớp");
      return;
    }

    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const response = await fetch(
        `${END_POINT}/api/affiliate/reset-password`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token, new_password: password }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setSuccess("Đặt lại mật khẩu thành công! Bạn sẽ được chuyển hướng...");
        setTimeout(() => {
          if (props.history) {
            props.history.push("/login");
          } else {
            window.location.href = "/login";
          }
        }, 2000);
      } else {
        setError(data.responseText || "Liên kết không hợp lệ hoặc đã hết hạn");
      }
    } catch (err) {
      console.error(err);
      setError("Lỗi kết nối server");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="aff-auth-page">
      <div className="aff-auth-wrapper">
        <div className="aff-auth-card">
          <div className="aff-auth-logo">
            <img
              src="/assets/img/logo-horizontal.svg"
              alt="VMASS Affiliate"
              style={{ height: "40px" }}
            />
          </div>

          <div className="aff-auth-header">
            <h1 className="aff-auth-title">
              {mode === "request" ? "Quên mật khẩu?" : "Đặt lại mật khẩu"}
            </h1>
            <p className="aff-auth-subtitle">
              {mode === "request"
                ? "Nhập email của bạn để nhận liên kết đặt lại mật khẩu"
                : "Nhập mật khẩu mới cho tài khoản của bạn"}
            </p>
          </div>

          {error && (
            <div className="aff-auth-error">
              <span>⚠️</span> {error}
            </div>
          )}

          {success && (
            <div className="alert alert-success p-3 rounded mb-4 text-sm font-medium">
              {success}
            </div>
          )}

          {mode === "request" ? (
            <form onSubmit={handleRequest} className="aff-auth-form">
              <div className="aff-auth-field">
                <label className="aff-auth-label">📧 Email đã đăng ký</label>
                <input
                  type="email"
                  className="aff-auth-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="name@example.com"
                />
              </div>

              <button type="submit" disabled={loading} className="aff-auth-btn">
                {loading ? (
                  <span className="aff-auth-spinner"></span>
                ) : (
                  "Gửi yêu cầu →"
                )}
              </button>
            </form>
          ) : (
            <form onSubmit={handleReset} className="aff-auth-form">
              <div className="aff-auth-field">
                <label className="aff-auth-label">🔒 Mật khẩu mới</label>
                <input
                  type="password"
                  className="aff-auth-input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  placeholder="It nhất 6 ký tự"
                  minLength={6}
                />
              </div>

              <div className="aff-auth-field">
                <label className="aff-auth-label">🔐 Nhập lại mật khẩu</label>
                <input
                  type="password"
                  className="aff-auth-input"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  placeholder="Xác nhận mật khẩu"
                />
              </div>

              <button type="submit" disabled={loading} className="aff-auth-btn">
                {loading ? (
                  <span className="aff-auth-spinner"></span>
                ) : (
                  "Đặt lại mật khẩu →"
                )}
              </button>
            </form>
          )}

          <div className="aff-auth-footer">
            <Link to="/login" className="aff-auth-link">
              ← Quay lại đăng nhập
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AffiliateForgotPassword;
